// extracted by mini-css-extract-plugin
export default {"root":"icon-link_root__YpwIL","active":"icon-link_active__EcTpV","placeHolderShimmer":"icon-link_placeHolderShimmer__hxhFz"};